const experience = [
    {
    job: `Web Developer II`,
    company: "Geiger",
    timeframe: "2024 - Current",
    achievements: [
      "Promoted to lead the development of our proprietary headless content management system built on PayloadCMS, integrated with our Next.js codebase.",
      "Responsible for containerizing services using Docker, automating the process by leveraging Bitbucket Pipelines, and coordinate with the IT team to deploying the app to AWS ECS. The CMS serves as an intermediary layer that distributes site-specific data via a GraphQL API, queried dynamically on a per-domain basis.",
      "Wrote concise documentation for feature additions to our codebase which ensures easy modulation and composition."
      ,]
  },
  {
    job: `Web Developer I`,
    company: "Geiger",
    timeframe: "2022 - 2024",
    achievements: [
      "Developed scalable and efficient B2B eCommerce solutions for various corporations including State Farm, Blue Cross, Hershey's, Bank of New York and Activision.",
      "Spearheaded implementing modular separation of concerns in our Next.js codebase to promote reusability and containerize data. This improved team efficiency by over 50%, and reduced the site development time from an entire day to just hours.",
      "Worked on a selective data integration team to integrate a headless CMS alternative to our eCommerce platform utilizing Typescript and GraphQL. This facilitated an even further reduction of development time.",
    ],
  }
]

export {experience}